export enum OnSaleEventMetricsName {
  Transactions = 'transactions',
  Clicks = 'clicks',
  ConversionRate = 'conversionRate',
}
